
































































import { get, sync } from 'vuex-pathify';
import { mapActions } from 'vuex';

import Vue from 'vue';
const reload = () => window.location.reload();

export default Vue.extend({
  name: 'AuthConfirmEmail',

  computed: {
    verified: get('auth/isVerified'),
    loading: get('auth/getLoading'),
    getError: get('error/getError'),
    companyName: sync('app/companyName'),
    key() {
      return this.$route.query.key;
    }
  },

  methods: {
    ...mapActions({
      verifyEmail: 'auth/verifyEmail'
    }),
    reload: () => reload()
  },

  async created() {
    await this.verifyEmail(this.key);
  }
});
